import { useSession } from 'technical/auth/client';
import { useGetScanSitesQuery } from './use-get-scan-sites-query';

export const useGetScanSitesData = () => {
  const { data: session } = useSession();

  const { data, error, isLoading } = useGetScanSitesQuery(session);

  return {
    data,
    loading: isLoading,
    error,
  };
};
